import { createSelector } from 'reselect';
import { PAGE_INDICES } from '../../actions/travelKe/types';
import { getTravelKe } from './index';

const getRouting = createSelector(getTravelKe, (state) => state.routing);
export const getActivePageIndex = createSelector(getRouting, (routing) => routing.activePageIndex);
export const getDoTravelInsuranceNavigation = createSelector(getRouting, (routing) => routing.doNavigation);
export const getDoExitMotorInsuranceNavigation = createSelector(getRouting, (routing) => routing.doExitNavigation);

export const getLandingPage = createSelector(getRouting, (routing) => routing.landingPage);

export const getIsDropoffPage = createSelector(
    getRouting,
    (routing) => routing.activePageIndex === PAGE_INDICES.ABOUT_YOU
);

const makeGetIsPage = (pageIndex) => createSelector(getRouting, (routing) => routing.activePageIndex === pageIndex);
export const getIsQuotePage = makeGetIsPage(PAGE_INDICES.QOUTE);
export const getIsSelectPlanPage = makeGetIsPage(PAGE_INDICES.SELECT_PLAN);
export const getIsConfirmDetailsPage = makeGetIsPage(PAGE_INDICES.CONFIRM_DETAILS);
export const getIsTravelerDetailsPage = makeGetIsPage(PAGE_INDICES.TRAVELER_DETAILS);
export const getIsPaymentPage = makeGetIsPage(PAGE_INDICES.PAYMENT);

export const getProgressBarIndex = createSelector(
    getIsQuotePage,
    getIsSelectPlanPage,
    getIsConfirmDetailsPage,
    getIsTravelerDetailsPage,
    getIsPaymentPage,
    (isQuotePage, isSelectPlanPage, isConfirmDetailsPage, isTravelerDetailsPage, isPaymentPage) => {
        if (isQuotePage) return 0;
        if (isSelectPlanPage) return 1;
        if (isConfirmDetailsPage) return 2;
        if (isTravelerDetailsPage) return 3;
        if (isPaymentPage) return 4;
    }
);
